// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__o9iHS","left":"styles_left__OOa9-"};